import React from 'react';

const InternetConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/pages/errors/internet-connectivity',
			component: React.lazy(() => import('./index.js'))
		}
	]
};

export default InternetConfig;
